import { BRAND_RESOURCES } from '@/constants/brand-resources';
import React, { useContext, useMemo } from 'react';
import MyIcon from '../my-icon';
import VersionTipText from '../version-tip-text';

import { NoPermissionContext } from './context';

import style from './index.less';

const NoPermission = ({ inModal = false, size = 'large', className = '' }) => {
  const { useEnterprise, useAgents } = useContext(NoPermissionContext);
  const { agentList } = useAgents();
  const { enterprise } = useEnterprise();
  const superAdmin = useMemo(() => {
    const superadmin_id = enterprise.superadmin_id || '';
    const agent = agentList.find(agent => agent.id === superadmin_id);
    if (agent) {
      return agent;
    }
    return {};
  }, [agentList, enterprise]);

  if (size === 'small') {
    return (
      <div className={`${className} ${style.content_small}`}>
        <div>
          <MyIcon className={style.icon} type={BRAND_RESOURCES.noPermissionIcon} />
          <div className={style.title}>抱歉，你的账号无此权限</div>
        </div>
      </div>
    );
  }

  return (
    <div className={inModal ? '' : style.wrap}>
      <div className={style.content}>
        <MyIcon className={style.icon} type={BRAND_RESOURCES.noPermissionIcon} />
        <div className={style.title}>{'抱歉，你的账号无此权限'}</div>
        <div className={style.desc}>{'如需使用该功能，请联系企业管理员开通权限'}</div>
        <div className={style.desc}>{'在工作台的【公共设置-企业管理-角色设置】中进行修改'}</div>
        <div className={style.super_content}>
          <div className={style.inner}>
            <img src={superAdmin.avatar} alt='头像' />
            <div>
              <div className={style.name}>{superAdmin.realname || superAdmin.nickname}</div>
              <div className={style.email}>{superAdmin.email}</div>
            </div>
          </div>
        </div>
      </div>
      <VersionTipText className={inModal ? style.tip : style.modal} />
    </div>
  );
};

NoPermission.NoPermissionContext = NoPermissionContext;

export default NoPermission;
